import { createAsyncThunk } from '@reduxjs/toolkit';

import type {
  ClasseJudicialFilters,
  Grau,
  TipoJustica,
} from '@/types/classeJudicial/classeJudicialTypes';

import { classeJudicialService } from './services';

export const listarClassesJudiciais = createAsyncThunk(
  'classeJudicial/listar',
  async (filters: ClasseJudicialFilters | undefined, { rejectWithValue }) => {
    try {
      return await classeJudicialService.listar(filters);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const buscarClasseJudicialPorId = createAsyncThunk(
  'classeJudicial/buscarPorId',
  async (id: string, { rejectWithValue }) => {
    try {
      return await classeJudicialService.buscarPorId(id);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const buscarClassesPorTipoJusticaEGrau = createAsyncThunk(
  'classeJudicial/buscarPorTipoJusticaEGrau',
  async ({ tipoJustica, grau }: { tipoJustica: TipoJustica; grau: Grau }, { rejectWithValue }) => {
    try {
      return await classeJudicialService.buscarPorTipoJusticaEGrau(tipoJustica, grau);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const buscarClassePorCodigo = createAsyncThunk(
  'classeJudicial/buscarPorCodigo',
  async (codigo: string, { rejectWithValue }) => {
    try {
      return await classeJudicialService.buscarPorCodigo(codigo);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);
